import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import * as libLocation from "../lib/location.ts";
import * as INR from "../INR.ts";
import * as websocket from "../util/websocket.js";
import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import {PlaceCache, PositionCache} from "../server/objects/MapBeans.js";
import * as i18n from "../i18n.ts";
import {initPaneRight} from "../util/PaneRight.ts"
import TPLmapPlaces from "../map/map_places.mustache";
import Icons from "../svg/Icons.ts";
import $ from "../$.js";

  var
    // Private field
    map,
    positionById,
    currentModal = null,
    lastRefreshByFamily = {};
 
  
  //TODO maybe put this globally
  websocket.subscribe(["GeolocPositionRefreshError"],function(msg){
    modal.alert(msg.push.message);
  });
  
  function editPlace(place){
    import("../map/place_edit.mustache").then(function(TPL){
      modal.closeModal()
      currentModal = modal.openModal(TPL,place);  
    });
    
  }
  function viewPlace(place){
    import("../map/place_view.mustache").then(function(TPL){
      currentModal = modal.openModal(TPL,place);  
    });
    
  }
  function mapcheckin(){
    import("../map/modal_checkin.mustache").then(function(TPL){
      currentModal = modal.openModal(TPL,{});  
    });
    
  }
  function closeModal(){
    if(currentModal!==null){
      modal.closeModal(currentModal);
      currentModal=null;
    }
  }
  
  function modalError(error){
    if(currentModal!==null){
      //FIXME i18n this
      modal.alert("Cannot localize place");
    }
  }
  function onSuccess(place){
    closeModal();
    PlaceCache.invalidate();
    amplify.publish("modified",["place"]);
    refresh()
    map.centerPlace(place);
    //libLocation.goTo("map.php?placeId="+place.metaId);
  }
  ApiServer['custom.poiupdate'] = ApiServer.poiupdate.prepare(onSuccess,modalError)
  ApiServer['custom.poicreate'] = ApiServer.poicreate.prepare(onSuccess,modalError)
  
  function showUserDetailsOverlay(location){
    if(location.accountId){
      import("../map/location_view.mustache").then(function(TPL){
        if(location.address && !location.address.formattedAddress){
          ApiServer.georeverse(location.address.latitudeE6,location.address.longitudeE6,function(geoAddress){
            //copy only data we do not have
            location.address.attribute0Country = geoAddress.attribute0Country;
            location.address.attribute1State = geoAddress.attribute1State;
            location.address.attribute2Town = geoAddress.attribute2Town;
            location.address.attribute3ZipCode = geoAddress.attribute3ZipCode;
            location.address.attribute4Line = geoAddress.attribute4Line;
            location.address.formattedAddress = geoAddress.formattedAddress;
            
            modal.openModal(TPL,location)
          });
        }else{
          modal.openModal(TPL,location)
        }
      });
    }
  }

  async function refresh(){
    //FIXME turn all that to promise
    var [places,newPositionById] = await Promise.all([PlaceCache.refresh(),PositionCache.refresh()]);
    positionById = newPositionById;
    updateFamilybarIcon(positionById);
    map.refresh(positionById,places.filter(place=>!place.isTemporary));
    majPlaceList(places)
  }
  
  function updateFamilybarIcon(positionById){
    $.each(positionById,function(key,obj){
      var 
        node = $("i[data-fw-menuicon-for='"+obj.accountId+"']");
      if(obj.geolocSharing==='NEVER'){
        node.html(Icons.ic_never)
      }else if(obj.geolocSharing==='PLACES'){
        node.html(Icons.ic_places)
      }
    });
  }
  
  function majPlaceList(placesWithTemporaries){
    var 
      places = placesWithTemporaries.filter(place=>!place.isTemporary);
    Html.setHtml ($("#map-places"), TPLmapPlaces, {empty:places.length===0,places}); 
    return places;
  }
  /*
    Function: loadMap()
    Create the map with the last check-in of each family member
  */
  async function loadMap (google_map) {
    var refreshDate = lastRefreshByFamily[FwDatas.getFamily().metaId];
    if(refreshDate==null || (new Date()-refreshDate)>600000){ //more than 10 minutes
      lastRefreshByFamily[FwDatas.getFamily().metaId] = new Date();
      ApiServer.locrequestpositionrefresh();
    }
    var 
      [placesWithTemporaries,newPositionById] = await Promise.all([PlaceCache.need(),PositionCache.need()]),
      params = libLocation.getURLParams(),
      places = majPlaceList(placesWithTemporaries);
    positionById = newPositionById;
    
    
    
    map = google_map.createMap(positionById,places);

    
    if(params.accountId){
      amplify.publish ("familyMemberSelected", {
        selected:  params.accountId
      });
    }else if(params.placeId){
      amplify.publish ("placeSelected", params.placeId);
    }else if(params.lat){
      map.centerAddress({latitude: parseInt(params.lat,10)/1E6,longitude: parseInt(params.lng,10)/1E6});
    }
  }

  INR.onPage(INR.URL.MAP,function(){
    
    initPaneRight()
    

    import("./googleApi.js").then(function(googleApi){
      googleApi.loadThen(function(){
        import("./google_map.js").then(googleMap=>{
          loadMap(googleMap);
          PositionCache.need().then(positionById=>{
            updateFamilybarIcon(positionById);
            $.each(positionById,function(key,obj){
              if(obj.panicButtonActivated){
                import('../modal/snack_simple.mustache').then(TPL=>{
                  modal.snack(TPL,{
                    color:"var(--red)",
                    icon:"notification_important",
                    title:i18n.get("map.panicButtonActivated",FwDatas.getProfile(obj.accountId).firstName)
                  },5000).node.on('click',function(){
                    Html.triggerbystring(null,"selectmember|"+obj.accountId)
                  })
                })
              }
            });
          });
          
        })
      });
    });
    INR.subscribe("handleParam",function(){
      import("./google_map.js").then(loadMap)
    });
    INR.subscribe ("pageUnload", function(){
      map.destroy();
    });
    INR.subscribe ("placeDeleted", function(){
      libLocation.goTo('map.php')
    });
    INR.subscribe ("familyMemberSelected", async function(event){
      await refresh();
      var position = positionById[event.selected];
      if(event.selected==="all"){
        map.centerFamilyMember(null,true);
      }else if(position){
        map.centerFamilyMember(position,true);
      }
      if(event.fromFamilybar===true){
        return;
      }
      if(event.selected===FwDatas.getAccountId() && (!position || !position.address)){
        mapcheckin()
      }else{
        showUserDetailsOverlay(position||new ApiServer.types.ILocation({accountId:event.selected}));
        if(event.fromFamilybar){
          $('*[data-fw-onclick="requestautotrack|'+event.selected+'"]').click();
        }  
      }
      
    
    });
    INR.subscribe ("placeSelected", function (placeId) {
      var place = FwDatas.get(placeId);
      map.centerPlace(place);
      viewPlace(place);
    });

    
  });
  Html.register({
    checkin(){
      var placeId = this.metaId();
      ApiServer.locpublishplacelocation(null,placeId,"IN",refresh);
    },
    maprefresh(){
      refresh().then(function(){
        var userOverlay = $("[data-fw-location-accountid]");
        if(userOverlay.length){
          var 
            accountId = userOverlay.attr("data-fw-location-accountid"),
            position = positionById[accountId];
          showUserDetailsOverlay(position||new ApiServer.types.ILocation({accountId:accountId}));
        }
        
      });
    },
    addplace(){
      editPlace();
    },
    
    editplace(){
      var
        node = this.metaIdNode(),
        id = node.metaId();
      editPlace (FwDatas.get(id));
    },
    mapcheckin,
    mapzoommore(){
      map.addZoom(1)
    },
    mapzoomless(){
      map.addZoom(-1)
    },
    placedelete(){
      modal.confirmDelete('mapLayout.deletePlaceConfirm',()=>{
        ApiServer.metadelete(this.metaId());
        PlaceCache.invalidate();
        modal.closeModal()
        amplify.publish('placeDeleted')
      })
    }
    
  });
  
  amplify.subscribe("mapcheckindone",function(){
    modal.closeModal();
    modal.toast({text:'map.checkin.done',button:[{title:"map.checkin.seepost",onclick:function(){libLocation.goTo('home.php')}}]})
    refresh()
    
  })
  